module.exports = __webpack_public_path__ + "img/smart_araucania.2fb3f231.png";